/* tslint:disable */
/* eslint-disable */
/**
 * Main data new API
 * Auto-generated openapi scheme for main-data-new API
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    ReadOnlyMonitoringDevice,
    ReadOnlyMonitoringDeviceFromJSON,
    ReadOnlyMonitoringDeviceFromJSONTyped,
    ReadOnlyMonitoringDeviceToJSON,
} from './';

/**
 * 
 * @export
 * @interface InlineResponse20034
 */
export interface InlineResponse20034 {
    /**
     * 
     * @type {number}
     * @memberof InlineResponse20034
     */
    count: number;
    /**
     * 
     * @type {string}
     * @memberof InlineResponse20034
     */
    next?: string | null;
    /**
     * 
     * @type {string}
     * @memberof InlineResponse20034
     */
    previous?: string | null;
    /**
     * 
     * @type {Array<ReadOnlyMonitoringDevice>}
     * @memberof InlineResponse20034
     */
    results: Array<ReadOnlyMonitoringDevice>;
}

export function InlineResponse20034FromJSON(json: any): InlineResponse20034 {
    return InlineResponse20034FromJSONTyped(json, false);
}

export function InlineResponse20034FromJSONTyped(json: any, ignoreDiscriminator: boolean): InlineResponse20034 {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'count': json['count'],
        'next': !exists(json, 'next') ? undefined : json['next'],
        'previous': !exists(json, 'previous') ? undefined : json['previous'],
        'results': ((json['results'] as Array<any>).map(ReadOnlyMonitoringDeviceFromJSON)),
    };
}

export function InlineResponse20034ToJSON(value?: InlineResponse20034 | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'count': value.count,
        'next': value.next,
        'previous': value.previous,
        'results': ((value.results as Array<any>).map(ReadOnlyMonitoringDeviceToJSON)),
    };
}


